import { Profile } from 'oidc-client';
import { AttachmentVm } from '../../../utils/api';
import AttachmentTable from './AttachmentTable';

interface OwnProps {
    userProfile: Profile;
    attachments?: AttachmentVm[];
    /** Set for a tool's documents: rights then follow the tool, not the attachment module. */
    toolId?: number;
    onUpdate: (id: number) => void;
    onDelete: (id: number) => Promise<void>;
}

export type Props = OwnProps;

export default AttachmentTable;
